export default __webpack_public_path__ + "static/media/minus.4a4bdce7.png";